import React from 'react';
import { InteractionLayerSizeV2, LayerHandleV2, ShimBackgroundTypeV2 } from '@volkswagen-onehub/layer-manager';
import { PortalContext } from '../../../context/portal-context';
import { Breakpoints, Container, ContainerPadding, CTA, styled } from '@volkswagen-onehub/components-core';
import { Close } from '@volkswagen-onehub/icons-core';
import { DataCollection } from '@esportal/portal-service';
import { DataCollectionForm } from '../components/data-collection-form';
import { useTrackingManager } from '../../../tracking/use-tracking-manager';

const CTARelativeContainer = styled.div`
	position: relative;

	z-index: 1000;
`;

export const DataCollectionLayer: React.FC<{
	dataCollection: DataCollection | null;
	setIsCloseFormLayerVisible: React.Dispatch<React.SetStateAction<boolean>>;
	setIsDataCollectionLayerVisible: React.Dispatch<React.SetStateAction<boolean>>;
	isDataCollectionLayerVisible: boolean;
	dataCollectionLayerRef: React.RefObject<LayerHandleV2<any>>;
}> = ({
	dataCollection,
	isDataCollectionLayerVisible,
	dataCollectionLayerRef,
	setIsCloseFormLayerVisible,
	setIsDataCollectionLayerVisible,
}) => {
	const { layerManager } = React.useContext(PortalContext);
	const portalContext = React.useContext(PortalContext);
	const isLastStepRef = React.useRef(false);
	const trackingManager = useTrackingManager();

	const handleClose = () => {
		if (isLastStepRef.current) {
			handleCloseFormLayer();
			trackingManager.trackClubVWLayerCloseClick('Data Collection Layer', { contentId: 'Data Collection' });
		} else {
			setIsCloseFormLayerVisible(true);
		}
	};

	const handleCloseFormLayer = () => {
		setIsDataCollectionLayerVisible(false);

		if (dataCollectionLayerRef?.current) {
			dataCollectionLayerRef.current.close();
			return ((dataCollectionLayerRef.current as any) = null);
		}
		return null;
	};

	const setIsLastStep = (value: boolean) => {
		isLastStepRef.current = value;
	};

	const renderDataCollectionForm = () => {
		return (
			<PortalContext.Provider value={portalContext}>
				<CTARelativeContainer className="cta__relative-container">
					<Container
						wrap={'never'}
						horizontalAlign={'flex-end'}
						verticalAlign={'center'}
						padding={{
							top: ContainerPadding.dynamic0100,
							right: {
								[Breakpoints.default]: ContainerPadding.grid001,
								[Breakpoints.b960]: ContainerPadding.dynamic0100,
							},
							bottom: ContainerPadding.static200,
						}}
					>
						<CTA
							tag="button"
							emphasis="tertiary"
							onClick={handleClose}
							aria-label="closePopUp"
							icon={<Close variant="default" aria-hidden />}
						/>
					</Container>
				</CTARelativeContainer>

				<DataCollectionForm
					dataCollection={dataCollection}
					handleCloseFormLayer={handleCloseFormLayer}
					setIsLastStep={setIsLastStep}
				/>
			</PortalContext.Provider>
		);
	};

	const renderInteractionLayer = (): any => {
		if (!dataCollectionLayerRef.current && isDataCollectionLayerVisible) {
			const layer = layerManager.openInteractionLayer(
				renderDataCollectionForm,
				{},
				{
					size: InteractionLayerSizeV2.B,
					shimBackgroundType: ShimBackgroundTypeV2.OPAQUE,
				},
			);
			(dataCollectionLayerRef.current as any) = layer;
		}
		return null;
	};

	return <>{isDataCollectionLayerVisible && renderInteractionLayer()}</>;
};
